export default "__VITE_ASSET__D0zc08S5__"